import { Chip, IconButton, Stack, Typography } from '@mui/material';
import { DynamicIcon, Tooltip } from 'src/components';

interface MacrosModalListHeaderProps {
  isManageMode: boolean;
  canManageMacros: boolean;
  onCreateMacro: () => void;
  onCreateFolder: () => void;
  onToggleManageMode: () => void;
}

export const MacrosModalListHeader = ({
  isManageMode,
  canManageMacros,
  onCreateMacro,
  onCreateFolder,
  onToggleManageMode,
}: MacrosModalListHeaderProps) => {
  return (
    <Stack direction="row" alignItems="center" justifyContent="space-between" gap={2}>
      <Stack direction="row" alignItems="center" gap={0.5}>
        {isManageMode ? <Chip label="Manage" size="small" color="primary" /> : null}
        {canManageMacros && isManageMode ? (
          <>
            <Tooltip title="New macro">
              <IconButton onClick={onCreateMacro} size="small">
                <DynamicIcon name="add" />
              </IconButton>
            </Tooltip>
            <Tooltip title="New folder">
              <IconButton onClick={onCreateFolder} size="small">
                <DynamicIcon name="create_new_folder" />
              </IconButton>
            </Tooltip>
          </>
        ) : null}

        <Tooltip title={canManageMacros ? 'Manage macros' : 'No permission to manage macros'}>
          <span>
            <IconButton onClick={onToggleManageMode} disabled={!canManageMacros} size="small">
              <DynamicIcon name="settings" />
            </IconButton>
          </span>
        </Tooltip>
      </Stack>
      <Typography variant="overline" color="text.secondary">
        Macros
      </Typography>
    </Stack>
  );
};
